module.exports = __webpack_public_path__ + "angular/app/layout-home-5ef17a28.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/app/layout-home.html
// module id = 78
// module chunks = 0